/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";

import { signInSuccess } from "../../../../store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../store/hook";
import * as RoleSelector from "src/store/role/selector.ts";
import { useState } from "react";
import { useUserSignIn } from "../../../../api/mutations/auth.mutation";
import { Card, CardBody, Container } from "react-bootstrap";

function EmpSettingForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    email: yup.string().required("Please enter your email"),
    password: yup.string().required("Please enter your password"),
    rememberMe: yup.bool(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useAppSelector(RoleSelector.selectUserRole);

  const userLoginMutation = useUserSignIn({
    onSuccess: (data) => {
      dispatch(signInSuccess("token"));
      navigate("/e");
    },
    onError: (error) => {
      if (error.message) {
      }
    },
    successMessage: "Login Successful!",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const onSignIn = (data) => {};

  return (
    <div id="content-page" className="content-inner">
      <Container>
        <Card className="">
          <Formik
            validationSchema={schema}
            onSubmit={onSignIn}
            initialValues={{
              email: "",
              password: "",
              rememberMe: false,
            }}
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit} className="">
                <Row className="mb-2">
                  <h3 className="mb-3">Setting</h3>
                  <Form.Group
                    as={Col}
                    controlId="validationFormikEmail"
                    className="form-group text-start"
                  >
                    <Form.Label className="form-label fw-bold">
                      Username or Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Your Full Name"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                      className="form-control mb-0"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    controlId="validationFormikPassword"
                    className="form-group text-start"
                  >
                    <Form.Label className="form-label fw-bold">
                      New Password
                    </Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                      className="form-control mb-0"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={handleTogglePassword}
                      className="mt-2"
                    >
                      {showPassword ? "Hide" : "Show"} Password
                    </Button>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    controlId="validationFormikPassword"
                    className="form-group text-start"
                  >
                    <Form.Label className="form-label fw-bold">
                      Confirm Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                      className="form-control mb-0"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <div className="text-end">
                  <Button
                    variant="success"
                    type="submit"
                    className="btn btn-success mt-4 fw-semibold text-uppercase"
                  >
                    Change Password
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </div>
  );
}

export default EmpSettingForm;
